import { useSelector } from "react-redux";
import UserList from "../component/UserList";
import AccessDenied from "../component/AccessDenied";
import { isTaskAllowed } from "../utils/isTaskAllowed";

const Users = () => {
    const { admin } = useSelector((state) => state.auth);

    if(admin?.email !== "admin@thriftyx.com" &&
        !isTaskAllowed("Users", admin?.assignedWork)) return (<AccessDenied />)

    return (<UserList />) 
}
export default Users;